import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "./ui/button";
import { needsPolicyAcceptance } from "../utils/policyConsent";

const API_URL = process.env.REACT_APP_API_URL;

const readUser = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

const PolicyConsentModal = () => {
  useLocation(); // fuerza re-render en cada navegación tras el login
  const [, forceTick] = useState(0);
  const [policyVersion, setPolicyVersion] = useState(null);
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const onSync = () => forceTick((n) => n + 1);
    window.addEventListener("user-sync", onSync);
    return () => window.removeEventListener("user-sync", onSync);
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/consent/policy-version`)
      .then((res) => setPolicyVersion(res.data?.version || null))
      .catch(() => setPolicyVersion(null));
  }, []);

  const user = readUser();
  const token = localStorage.getItem("token");

  if (!token || !user || !policyVersion) return null;
  if (!needsPolicyAcceptance(user, policyVersion)) return null;

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("servicioActivo");
    sessionStorage.clear();
    window.location.assign("/login");
  };

  const handleAccept = async () => {
    if (!checked) return;
    setSubmitting(true);
    try {
      await axios.post(
        `${API_URL}/consent/policies`,
        { version: policyVersion },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const updatedUser = {
        ...user,
        policyAcceptance: {
          version: policyVersion,
          acceptedAt: new Date().toISOString(),
        },
      };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      window.dispatchEvent(new Event("user-sync"));
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "No se pudo registrar la aceptación de las políticas",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-2xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-gray-800">
          Actualizamos nuestras políticas
        </h2>
        <p className="text-sm text-gray-600">
          Para continuar usando Previonix debes leer y aceptar la Política de
          Privacidad y la Autorización de Tratamiento de Datos Personales.
        </p>
        <div className="flex gap-4 text-sm">
          <a
            href="/politica-privacidad"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            Política de Privacidad
          </a>
          <a
            href="/tratamiento-datos"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            Tratamiento de Datos
          </a>
        </div>
        <label className="flex items-start gap-2 text-sm text-gray-700">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            disabled={submitting}
            className="mt-1"
          />
          He leído y acepto la Política de Privacidad y la Autorización de
          Tratamiento de Datos Personales.
        </label>
        <Button
          className="w-full"
          disabled={!checked || submitting}
          onClick={handleAccept}
        >
          {submitting ? "Guardando..." : "Aceptar y continuar"}
        </Button>
        <button
          type="button"
          onClick={handleLogout}
          disabled={submitting}
          className="w-full text-sm text-gray-500 hover:text-gray-700 underline disabled:opacity-50"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
};

export default PolicyConsentModal;
